// Check if user should see account storage on Contact Screen
export const showAccountStorage = (
    isApiBillingPlan: boolean,
    isSub: boolean,
    maxContacts: number,
    planMaxContacts: number
): boolean => {
    let showStorage: boolean;
    if (isSub) {
        showStorage = maxContacts !== 0;
    } else {
        showStorage = !isApiBillingPlan && (maxContacts !== 0 || planMaxContacts !== 0);
    }

    return showStorage;
};
